module.exports = __webpack_public_path__ + "img/IMG_5896.78ddfee6.jpg";